import { useEffect } from 'react'
import { API_URL } from '../environment'
import { handleAuthentication } from '../utils/auth'
import { getTracking } from '../utils/tracking'

const SIGNUP_COMPLETE_EVENT = 'signupComplete'

const createSignUpHandler = next => e => {
  const { event, user, login_url, is_new, backend } = e.data
  if (event === SIGNUP_COMPLETE_EVENT && user && user.id) {
    handleAuthentication({
      isNew: is_new,
      provider: backend,
      user,
      login_url,
      next,
    })
  }
}

const useSocialAuth = next => {
  useEffect(() => {
    const handleSignUp = createSignUpHandler(next)

    window.addEventListener('message', handleSignUp, false)

    return () => {
      window.removeEventListener('message', handleSignUp)
    }
  }, [next])

  const startGoogleSignUp = () => {
    const url = new URL(
      `${API_URL}/socialauth-begin/google-oauth2/?mode=signup-popup`,
    )
    url.searchParams.set('tracking', JSON.stringify(getTracking()))

    window.open(url.href, '_blank', 'location=yes,scrollbars=yes,status=yes')
  }

  return { startGoogleSignUp }
}

export default useSocialAuth
